// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609280857/js/" + chunkId + "." + {"44":"5aef154f","225":"3ce6aec3","481":"6d5f771b","486":"0e4dfbe7","770":"3faf39a4"}[chunkId] + ".0.14816570336640855.chunk.js";
};